import { ReactNode } from 'react';

export function MatcherStandardStepSubtitleText({
  children
}: Readonly<{ children: ReactNode }>) {
  return <p className="text-3 mb-4 text-gray-60 sm:text-4">{children}</p>;
}
